export default "__VITE_PUBLIC_ASSET__e71b99ee__"